import React from 'react';
import { company } from '../mock/mock';

const MESSAGE = encodeURIComponent("Hi Interscope Ads, I'd like to discuss performance marketing / user acquisition for my app.");

export default function WhatsAppButton() {
  const href = `https://wa.me/${company.whatsapp}?text=${MESSAGE}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="group fixed bottom-5 right-5 z-[60] flex items-center gap-2"
    >
      <span className="hidden sm:inline-block max-w-0 overflow-hidden whitespace-nowrap rounded-full bg-[#25D366] text-[#04140a] text-sm font-semibold pr-0 group-hover:max-w-[180px] group-hover:pl-4 group-hover:pr-2 py-2.5 transition-all duration-300">
        Chat with us
      </span>
      <span className="relative grid place-items-center w-14 h-14 rounded-full bg-[#25D366] shadow-lg shadow-[#25D366]/40 group-hover:scale-105 transition-transform">
        <span className="absolute inset-0 rounded-full bg-[#25D366] ping-slow opacity-70" />
        <svg viewBox="0 0 32 32" className="relative w-7 h-7" fill="#04140a" aria-hidden>
          <path d="M16.001 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.6 4.46 1.73 6.4L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.23 1.62h.01c7.06 0 12.8-5.74 12.8-12.8s-5.75-12.8-12.81-12.8Zm0 23.04h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.9 1.02 1.04-3.8-.25-.4a10.56 10.56 0 0 1-1.62-5.64c0-5.86 4.77-10.63 10.64-10.63 2.84 0 5.5 1.11 7.51 3.12a10.55 10.55 0 0 1 3.11 7.52c0 5.86-4.77 10.62-10.63 10.62Zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.58-.95-.85-1.59-1.9-1.78-2.22-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.72-.98-2.35-.26-.62-.52-.54-.71-.55-.18-.01-.4-.01-.61-.01-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.65 0 1.56 1.14 3.07 1.3 3.28.16.21 2.25 3.44 5.46 4.83.76.33 1.36.52 1.82.67.77.24 1.46.21 2.01.13.61-.09 1.89-.77 2.16-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37Z" />
        </svg>
      </span>
    </a>
  );
}
